// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.SelectTenantPopup.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as _ from 'lodash/fp';
import { observable, toJS } from 'mobx';

import connect from 'share/enhancers/Izenda.Connect';
import localizer from 'share/localization/Izenda.Localizer';
import Popup from 'share/components/controls/CommonPopup/Izenda.Popup';
import SelectTenant from 'share/components/controls/SelectTenant/Izenda.SelectTenant';
import TenantManagementStore from 'logic/Izenda.TenantManagementStore';
import { EMPTY_GUID } from 'logic/data/Izenda.AppGlobalConstants';
import ScrollBox from 'share/components/controls/Izenda.ScrollBox';

@connect()
export default class SelectTenantPopup extends Component {

  static propTypes = {
    selectedItems: PropTypes.array.isRequired
  };

  /**
   * Collection of grouped tenants
   * @type {Array<{checked: boolean, tenantGroupName: string, tenantGroupItems: Array}>}
   */
  @observable tenantGroups = [];

  componentDidMount() {
    const { selectedItems } = this.props;
    // Load tenant groups and its tenants from API
    TenantManagementStore.getTenantGroupsHierarchy(selectedItems).then(tenantGroups => {
      this.tenantGroups = tenantGroups;
    });
  }

  /**
   * Get checked tenantId's
   * @returns {Array<string>} Array of tenantId's
   */
  getListOfCheckedTenants() {
    const tenantGroupsJs = toJS(this.tenantGroups);

    // Get all checked tenant groups
    const tenantGroups = _.flow(
      _.filter({ checked: true }),
      _.map(x => ({
        id: x.tenantGroupId,
        name: `Tenant Group: ${x.tenantGroupName}`,
        isTenantGroup: true
      })),
      _.uniqBy('id')
    )(tenantGroupsJs);

    // Here we're getting the list of tenants with checked individually without checking a whole group.
    const tenants = _.flow(
      _.filter({ checked: false }),
      _.flatMap(x => x.tenantGroupItems),
      _.filter({ checked: true }),
      _.map(x => ({
        id: x.tenantId,
        name: `Tenant: ${x.tenantName}`,
        isTenantGroup: false
      })),
      _.uniqBy('id')
    )(tenantGroupsJs);

    return _.concat(tenantGroups, tenants);
  }

  onSuccessInner = () => {
    const checkedTenants = this.getListOfCheckedTenants();
    this.props.onAccept(checkedTenants);
  };

  onRejectInner = () => {
    this.props.onReject();
  };

  /**
   * Handle when popup closing
   * @param  {Function} callback function
   * @param  {string} type of close button click
   */
  onClosing = (callback, type) => {
    if (type === 'accept') {
      this.onSuccessInner();
    } else if (type === 'cancel') {
      this.onRejectInner();
    }
  };

  render() {
    return (
      <Popup visible onClosing={this.onClosing} type='none' autoClose={false}>
        <Popup.Header title={localizer.getText('SELECT_TENANT_POPUP_HEADER')}/>
        <Popup.Body>
          <ScrollBox autoHeight autoHeightMax={500} autoHeightMin={500}>
            <SelectTenant tenantGroups={this.tenantGroups}/>
          </ScrollBox>
        </Popup.Body>
        <Popup.Footer>
          <Popup.ConfirmationButton key="accept" type="accept">
            {localizer.getText('COMMON_LABEL_OK')}
          </Popup.ConfirmationButton>
          <Popup.ConfirmationButton key="cancel" type="cancel">
            {localizer.getText('COMMON_LABEL_CANCEL')}
          </Popup.ConfirmationButton>
        </Popup.Footer>
      </Popup>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/share/components/controls/SelectTenantPopup/Izenda.SelectTenantPopup.js